import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    formDialogContent: {
      padding: '10px 10px 0px 10px',
      '&.MuiCardContent-root:last-child': {
        paddingBottom: 0
      },
      '&.MuiDialogContent-root:first-child': {
        paddingTop: 0
      }
    },
    noPaddingDialogContent: {
      padding: 0,
      '&.MuiCardContent-root:last-child': {
        paddingBottom: 0
      },
      '&.MuiDialogContent-root:first-child': {
        paddingTop: 0
      }
    },
    formDialogActions: {
      padding: 0
    },
    formDialogContentCustom: {
      padding: '10px 10px 0px 10px',
      '&.MuiCardContent-root:last-child': {
        paddingBottom: 0
      },
      '&.MuiDialogContent-root:first-child': {
        paddingTop: 0
      },
      // Eliminar min-height del Toolbar del Form (espacio en blanco debajo del título)
      '& .MuiToolbar-regular': {
        minHeight: '0px !important',
        '@media (min-width: 0px) and (orientation: landscape)': {
          minHeight: '0px !important'
        },
        '@media (min-width: 600px)': {
          minHeight: '0px !important'
        }
      },
      // Eliminar padding del último CardContent (espacio en blanco al final del formulario)
      // sirve si hay otro componente debajo y queremos que parezca un solo bloque sin espacios
      '& .MuiCardContent-root:last-child': {
        paddingBottom: '0px !important'
      }
    },
    confirmationDialogWithTitle: {
      minHeight: '68px',
      marginTop: theme.spacing(2)
    },
    confirmationDialogWithoutTitle: {
      minHeight: '38px'
    },
    confirmationDialogContentText: {
      textAlign: 'justify'
    },
    confirmationDialogActions: {
      margin: '14px'
    },
    confirmationDialogRoot: {
      '& *:focus': {
        outline: 'none !important'
      }
    }
  })
